import { PHONE_METHOD } from "@constants/form-constants";
import { ApplicationState, VerificationFormState } from "@idw-types/state";
import { AttributeStatusTypes } from "@enums/attribute-status-types";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { createSelector } from "reselect";

export const getVerificationFormState = (state: ApplicationState) => {
    return state.verificationForm;
};

export const getAttributeData = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.attributeData || [];
});

export const getPreviouslySavedAttributeData = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.previouslySavedAttributeData || [];
});

export const getShowAsyncModal = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.showAsyncModal || false;
});

export const getVerificationProcessed = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.verificationProcessed;
});

export const getAsyncCompleted = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.asyncCompleted || false;
});

export const getIsDcuiProcessCompleted = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.isDcuiProcessCompleted || false;
});

export const getShouldRetryVerification = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.shouldRetryVerification || false;
});

export const getAssertionErrorMessages = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.assertionErrorMessages || [];
});

export const getShowAsyncButton = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.showAsync;
});

export const getShowAsyncModalCancelButton = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.showAsyncModalCancelButton;
});

export const getAsyncMethod = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.asyncMethod || PHONE_METHOD;
});

export const getAsyncModalMessage = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.asyncModalMessage || "common.asyncModal.waiting";
});

export const getAsyncButtonText = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.asyncButtonText;
});

export const getDisableAsync = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.disableAsync || false;
});

export const shouldHighlightInput = createSelector(
	getShouldRetryVerification,
	(_: any, attribute: AttributeFormState) => attribute,
	(shouldRetryVerification, attribute) => shouldRetryVerification && attribute.status === AttributeStatusTypes.NEW
);

export const getFocusedAttributeId = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.focusedAttributeID || null;
});

export const getDCUICancelCount = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.dcuiCancelCount || 0;
});

export const getDCUICancelMax = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.dcuiCancelMax || 0;
});

export const getHasMaximumDCUICancelRetries = createSelector(getDCUICancelCount, getDCUICancelMax, (dcuiCancelCount, dcuiCancelMax) => {
    return dcuiCancelCount >= dcuiCancelMax;
});

export const getAllowDCUIretry = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.allowDCUIRetry || false;
});

export const getAsyncTimeoutID = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.asyncTimeoutID || null;
});

export const getAttempt = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.attempt;
});

export const getExplicitConsentChecked = createSelector(getVerificationFormState, (verificationForm: VerificationFormState) => {
    return verificationForm.explicitConsentChecked;
});